import './_table-mass-actions.scss'
import './_table-mass-actions.dark-mode.scss'
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const TableMassActions = ({ children, count, counterTitle, name, checked, onChange, disabled }) => (
  <div className={classNames('mass-actions', {
    'mass-actions__active': checked,
  })}
  >
    <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} />
    {checked
      ? (
        <div className="mass-actions__selected">
          <div className="mass-actions__selected-title">
            {count}
            {' '}
            {counterTitle}
            {' '}
            selected
          </div>
          <div className="mass-actions__selected-actions">
            {children}
          </div>
        </div>
      ) : null}
  </div>
);

TableMassActions.propTypes = {
  children: PropTypes.object,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  counterTitle: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

TableMassActions.defaultProps = {
  count: 0,
  disabled: false,
  name: 'mass_action',
};

export default TableMassActions;
